// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/silksong-1.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Geist:wght@100..900&family=Instrument+Serif:ital@0;1&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Geist", sans-serif;
}

:root {
  --c-dark-red: #cb131a;
  --c-red: #e83046;
  --c-black: #121212;
  --c-white: #faf9f6;
}

body {
  min-height: 100vh;
  background: var(--c-white);
  display: flex;
  flex-direction: column;
  position: relative;
}

p {
  font-size: 0.875rem;
  color: var(--c-black);
  line-height: 1.4;
}

a {
  color: var(--c-black);
  transition: opacity 0.3s ease;
}

a:hover {
  opacity: 0.7;
}

.wrapper {
  margin: 0 auto;
  max-width: 1200px;
}

svg {
  width: 16px;
  height: 16px;
}

h1,
section h1 {
  margin: 0;
  font-size: 1.75rem;
  line-height: 1.1;
}

:where(h1) {
  margin: 0;
  font-size: 1.75rem;
}

h2 {
  font-size: 1.25rem;
}

/* == SECTION == */
div.slanted {
  background: var(--c-red);
  width: 100vw;
  max-width: 100%;
  height: 300px;
  transform: skewY(-8deg) scaleY(3) translateY(-40%);
  position: absolute;
  top: 0;
}

section.top {
  padding: 4.25rem 3rem 3rem;
  z-index: 1;
  width: 100%;
  min-height: 300px;
  display: flex;
}

section.top > .left {
  aspect-ratio: 1 / 1;
  min-width: 230px;
  min-height: 100%;
  background: pink;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 15% center;
  background-size: cover;
  transform: scale(1.25) translateX(1rem);
  display: flex;
  justify-content: center;
  align-items: end;
}

section.top > .left p {
  font-family: "Instrument Serif", serif;
  font-size: 2.5rem;
  font-weight: bold;
  color: white;
}

section.top > .right {
  padding: 1rem 2rem 1.5rem 4.25rem;
  background: var(--c-white);
  color: var(--c-black);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.5rem;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.2);
}

section.top > .right .social-media-container {
  align-self: end;
  display: flex;
  justify-content: end;
  align-items: end;
  gap: 1rem;
  flex: 1;
}

/* == MAIN == */
main {
  padding: 2rem 3rem 3rem 2.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.areas-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.75rem;
}

.area {
  display: flex;
  flex-direction: column;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
}

.area img {
  width: 100%;
  min-height: 198px;
  border-radius: 20px 20px 0 0;
}

.area > .bottom {
  padding: 1rem 1.5rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.area-details-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
}

.area-details-container h2 {
  flex: 1;
}

.area-details-container > .links {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* == FOOTER == */
footer {
  width: 100%;
  background: var(--c-red);
}

footer > div {
  padding: 2rem 3rem 2rem 2.5rem;
  color: var(--c-white);
  display: flex;
  justify-content: space-between;
  gap: 3rem;
}

footer p,
footer address {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--c-white);
}

footer > div > .left {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

footer .contact-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

footer .phone-container,
footer .email-container,
footer .social-media-container {
  display: flex;
  gap: 0.5rem;
}

footer .social-media-container {
  margin-top: 0.5rem;
  gap: 1rem;
}

footer .social-media-container a {
  padding: 0.4rem;
  width: 40px;
  height: 40px;
  background: var(--c-white);
  color: var(--c-dark-red);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

footer > div > .right img {
  width: 100%;
  max-width: 700px;
  max-height: 320px;
}

/* == MEDIA QUERIES == */

@media (max-width: 900px) {
  section.top {
    padding-top: 6rem;
    padding-bottom: 1rem;
    display: block;
    width: 100%;
  }
  section.top > .left {
    margin-right: 2.75rem;
    margin-bottom: 1.5rem;
    aspect-ratio: none;
    max-width: 250px;
    max-height: 250px;
    z-index: 2;
    transform: scale(1.2) translateY(0);
    float: left;
  }
  section.top > .right {
    padding-left: 2rem;
    display: block;
  }
  section.top > .right p {
    margin: 0.4rem 0;
  }
  footer > div > .right img {
    height: 100%;
    object-fit: cover;
  }
}

@media (max-width: 620px) {
  section.top {
    display: flex;
    padding: 1.5rem;
    flex-direction: column;
    gap: 1.5rem;
  }
  section.top > .left {
    float: none;
    position: static;
    aspect-ratio: none;
    min-width: 100%;
    max-height: 300px;
    transform: scale(1) translateX(0rem);
    margin-bottom: 0;
  }
  section.top > .left p {
    font-size: 3.5rem;
    transform: translateX(0px) translateY(0px);
  }
  section.top > .right {
    padding: 0;
    box-shadow: none;
    display: flex;
  }
  section.top > .right h1 {
    text-align: center;
  }
  section.top > .right .social-media-container {
    align-self: center;
    margin-top: 1rem;
    gap: 1.5rem;
  }
  section.top > .right .social-media-container svg {
    width: 24px;
    height: 24px;
  }
  main {
    padding: 1.5rem;
  }
  main h1 {
    text-align: center;
  }
  footer > div {
    padding: 1.5rem 1.5rem 0;
    flex-direction: column;
  }
  footer > div > .left h1 {
    text-align: center;
  }
  footer > div > .left .social-media-container {
    align-self: center;
  }
  footer > div > .right img {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kDAAkD;EAClD,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,0BAA0B;EAC1B,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yDAAyD;EACzD,+BAA+B;EAC/B,sBAAsB;EACtB,uCAAuC;EACvC,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,OAAO;AACT;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;EAGE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wBAAwB;;AAExB;EACE;IACE,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,mCAAmC;IACnC,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,oCAAoC;IACpC,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,0CAA0C;EAC5C;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Geist:wght@100..900&family=Instrument+Serif:ital@0;1&display=swap\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Geist\", sans-serif;\n}\n\n:root {\n  --c-dark-red: #cb131a;\n  --c-red: #e83046;\n  --c-black: #121212;\n  --c-white: #faf9f6;\n}\n\nbody {\n  min-height: 100vh;\n  background: var(--c-white);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\np {\n  font-size: 0.875rem;\n  color: var(--c-black);\n  line-height: 1.4;\n}\n\na {\n  color: var(--c-black);\n  transition: opacity 0.3s ease;\n}\n\na:hover {\n  opacity: 0.7;\n}\n\n.wrapper {\n  margin: 0 auto;\n  max-width: 1200px;\n}\n\nsvg {\n  width: 16px;\n  height: 16px;\n}\n\nh1,\nsection h1 {\n  margin: 0;\n  font-size: 1.75rem;\n  line-height: 1.1;\n}\n\n:where(h1) {\n  margin: 0;\n  font-size: 1.75rem;\n}\n\nh2 {\n  font-size: 1.25rem;\n}\n\n/* == SECTION == */\ndiv.slanted {\n  background: var(--c-red);\n  width: 100vw;\n  max-width: 100%;\n  height: 300px;\n  transform: skewY(-8deg) scaleY(3) translateY(-40%);\n  position: absolute;\n  top: 0;\n}\n\nsection.top {\n  padding: 4.25rem 3rem 3rem;\n  z-index: 1;\n  width: 100%;\n  min-height: 300px;\n  display: flex;\n}\n\nsection.top > .left {\n  aspect-ratio: 1 / 1;\n  min-width: 230px;\n  min-height: 100%;\n  background: pink;\n  background-image: url(\"../assets/images/silksong-1.webp\");\n  background-position: 15% center;\n  background-size: cover;\n  transform: scale(1.25) translateX(1rem);\n  display: flex;\n  justify-content: center;\n  align-items: end;\n}\n\nsection.top > .left p {\n  font-family: \"Instrument Serif\", serif;\n  font-size: 2.5rem;\n  font-weight: bold;\n  color: white;\n}\n\nsection.top > .right {\n  padding: 1rem 2rem 1.5rem 4.25rem;\n  background: var(--c-white);\n  color: var(--c-black);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 0.5rem;\n  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.2);\n}\n\nsection.top > .right .social-media-container {\n  align-self: end;\n  display: flex;\n  justify-content: end;\n  align-items: end;\n  gap: 1rem;\n  flex: 1;\n}\n\n/* == MAIN == */\nmain {\n  padding: 2rem 3rem 3rem 2.5rem;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.areas-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.75rem;\n}\n\n.area {\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.2);\n  border-radius: 20px;\n}\n\n.area img {\n  width: 100%;\n  min-height: 198px;\n  border-radius: 20px 20px 0 0;\n}\n\n.area > .bottom {\n  padding: 1rem 1.5rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.area-details-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 3rem;\n}\n\n.area-details-container h2 {\n  flex: 1;\n}\n\n.area-details-container > .links {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* == FOOTER == */\nfooter {\n  width: 100%;\n  background: var(--c-red);\n}\n\nfooter > div {\n  padding: 2rem 3rem 2rem 2.5rem;\n  color: var(--c-white);\n  display: flex;\n  justify-content: space-between;\n  gap: 3rem;\n}\n\nfooter p,\nfooter address {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--c-white);\n}\n\nfooter > div > .left {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\nfooter .contact-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\nfooter .phone-container,\nfooter .email-container,\nfooter .social-media-container {\n  display: flex;\n  gap: 0.5rem;\n}\n\nfooter .social-media-container {\n  margin-top: 0.5rem;\n  gap: 1rem;\n}\n\nfooter .social-media-container a {\n  padding: 0.4rem;\n  width: 40px;\n  height: 40px;\n  background: var(--c-white);\n  color: var(--c-dark-red);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nfooter > div > .right img {\n  width: 100%;\n  max-width: 700px;\n  max-height: 320px;\n}\n\n/* == MEDIA QUERIES == */\n\n@media (max-width: 900px) {\n  section.top {\n    padding-top: 6rem;\n    padding-bottom: 1rem;\n    display: block;\n    width: 100%;\n  }\n  section.top > .left {\n    margin-right: 2.75rem;\n    margin-bottom: 1.5rem;\n    aspect-ratio: none;\n    max-width: 250px;\n    max-height: 250px;\n    z-index: 2;\n    transform: scale(1.2) translateY(0);\n    float: left;\n  }\n  section.top > .right {\n    padding-left: 2rem;\n    display: block;\n  }\n  section.top > .right p {\n    margin: 0.4rem 0;\n  }\n  footer > div > .right img {\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n@media (max-width: 620px) {\n  section.top {\n    display: flex;\n    padding: 1.5rem;\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n  section.top > .left {\n    float: none;\n    position: static;\n    aspect-ratio: none;\n    min-width: 100%;\n    max-height: 300px;\n    transform: scale(1) translateX(0rem);\n    margin-bottom: 0;\n  }\n  section.top > .left p {\n    font-size: 3.5rem;\n    transform: translateX(0px) translateY(0px);\n  }\n  section.top > .right {\n    padding: 0;\n    box-shadow: none;\n    display: flex;\n  }\n  section.top > .right h1 {\n    text-align: center;\n  }\n  section.top > .right .social-media-container {\n    align-self: center;\n    margin-top: 1rem;\n    gap: 1.5rem;\n  }\n  section.top > .right .social-media-container svg {\n    width: 24px;\n    height: 24px;\n  }\n  main {\n    padding: 1.5rem;\n  }\n  main h1 {\n    text-align: center;\n  }\n  footer > div {\n    padding: 1.5rem 1.5rem 0;\n    flex-direction: column;\n  }\n  footer > div > .left h1 {\n    text-align: center;\n  }\n  footer > div > .left .social-media-container {\n    align-self: center;\n  }\n  footer > div > .right img {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
